/**
 * Shared `bxiapikey` header value for the admin app.
 *
 * SECURITY: no hardcoded fallback. A committed fallback meant that whenever
 * REACT_APP_BXI_API_KEY was unset at build time, a known git-history value
 * silently became the live gateway key. We fail closed instead — the build
 * must supply REACT_APP_BXI_API_KEY. (Backend mirrors this: BXI_API_KEY is
 * `required: true` in BXI/config/env.js.)
 *
 * NOTE: this is an application identifier shipped in the client bundle, not a
 * per-user secret. Real authorization is enforced server-side via the admin
 * session token; this key only gates reaching the API.
 */
export function getBxiApiKey() {
  const key = process.env.REACT_APP_BXI_API_KEY;
  if (!key) {
    throw new Error(
      'REACT_APP_BXI_API_KEY is not set. Configure it in the build environment; ' +
        'there is no hardcoded fallback.'
    );
  }
  return key;
}
